var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message failure"},[_c('v-alert',{attrs:{"show":"","type":"error"}},[_vm._t("default",[_vm._v("Something went terribly wrong, please try again")])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }